import React, { useEffect, useState } from 'react';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import _get from 'lodash/get';

import * as S from './Styled';
import Spinner from '../Spinner';
import { useTranslation } from 'react-i18next';

const AddressAutocomplete = ({
  placeholder = null,
  searchOptions = {},
  onSelect = () => null,
  debounce = 500,
  fetchBrowserGeo = () => console.warn('No action'),
  current = null,
  onChange = () => {},
}) => {
  const [address, setAddress] = useState('');
  const { t } = useTranslation();
  useEffect(() => {
    setAddress(_get(current, 'address', ''));
  }, [current]);

  const randomId = Math.random().toString(36).substring(7);

  const handleSelect = async selected => {
    try {
      setAddress(selected);
      let results = await geocodeByAddress(selected);
      let coords = await getLatLng(results[0]);

      return onSelect({
        name: results[0].address_components[0].long_name,
        address: selected,
        latitude: coords.lat,
        longitude: coords.lng,
      });
    } catch (e) {
      console.error(e);
    }
  };

  const handleError = err => {
    console.error(err);
  };

  return (
    <S.Container>
      <PlacesAutocomplete
        value={address}
        debounce={debounce}
        onChange={value => {
          setAddress(value);
          if (onChange) {
            onChange(value);
          }
        }}
        onSelect={handleSelect}
        onError={handleError}
        searchOptions={{
          componentRestrictions: { country: 'ua' },
          ...searchOptions,
        }}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div>
            <S.AutocompleteInput
              id={randomId}
              {...getInputProps({
                placeholder: t(`labels.enter_the_address`),
              })}
            />
            <label htmlFor={randomId}>{placeholder}</label>

            <div onClick={fetchBrowserGeo}>
              <S.GeoIcon name="geo_target" />
            </div>

            <S.SuggestionsContainer>
              {loading && (
                <S.LoaderPadding>
                  <Spinner />
                </S.LoaderPadding>
              )}

              {suggestions.map(suggestion => (
                <S.SuggestionItem {...getSuggestionItemProps(suggestion)}>
                  <p>{suggestion.formattedSuggestion.mainText}</p>
                  <p>{suggestion.formattedSuggestion.secondaryText}</p>
                  <hr />
                </S.SuggestionItem>
              ))}
            </S.SuggestionsContainer>
          </div>
        )}
      </PlacesAutocomplete>
    </S.Container>
  );
};

export default AddressAutocomplete;
